import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import CustomButton from '../components/CustomButton';
import JobCard from '../components/JobCard';
import CompanyForm from './updateCompany';
import Loading from '../components/Loading';
import { FiEdit3, FiUpload, FiPhoneCall } from 'react-icons/fi';
import { AiOutlineMail } from 'react-icons/ai';
import { HiLocationMarker } from 'react-icons/hi';


const CompanyProfile = () => {
  const { id } = useParams();
 const [info, setInfo] = useState(null);
 const [jobs, setJobs] = useState([]);
 const [isLoading, setIsLoading] = useState(false);
 const [openForm, setOpenForm] = useState(false);
 const [role, setRole] = useState("seeker");
 const [profileUrl, setProfileUrl] = useState("");
 const [isCompany, setIsCompany] = useState(false);
 

 useEffect(() => {
    const userToken = localStorage.getItem('token');
    const checkRole = localStorage.getItem('role');
    setRole(checkRole);
    if (userToken) {
      try {
        const decoded = jwtDecode(userToken);
        const userId = decoded.userId;
        if (userId === id) {
          setIsCompany(true);
        }
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
 }, [id]);

 useEffect(() => {
  const fetchData = async () => {
    setIsLoading(true);
    try {
      let userId = id; // First attempt to use id from URL parameters

      if (!userId) {
        const userToken = localStorage.getItem("token");
        if (userToken) {
          try {
            const decoded = jwtDecode(userToken);
            userId = decoded.userId; // Fallback to using userId from decoded token
          } catch (error) {
            console.error("Token verification failed:", error.message);
          }
        }
      }

      if (userId) {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/company/get-company-joblisting`, {
          id: userId
        });
        setJobs(response.data.companies.jobPosts || []);
        setProfileUrl(response.data.companies.profileUrl);
        setInfo(response.data.companies);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching job listings:', error);
      setIsLoading(false);
    }
  };
  fetchData();
}, [id]);


 if (isLoading) {
    return <Loading />;
 }

 return (
    <div className='container mx-auto p-5'>
      <div>
        <div className='w-full flex flex-col md:flex-row gap-3 justify-between'>
          <h2 className='text-gray-600 text-xl font-semibold'>
            Welcome, {info?.name}
          </h2>
          {isCompany && role === "company" && (
            <div className='flex items-center justify-center bg-red-50 py-5 md:py-0 gap-4'>
              <p>Update company Profile</p>
              <CustomButton
                onClick={() => setOpenForm(true)}
                iconRight={<FiEdit3 />}
                containerStyles={`py-1.5 px-3 md:px-5 focus:outline-none bg-blue-600 hover:bg-blue-700 text-white rounded text-sm md:text-base border border-blue-600`}
              />
              <Link to='/upload-job'>
                <CustomButton
                 title='Upload Job'
                 iconRight={<FiUpload />}
                 containerStyles={`text-blue-600 py-1.5 px-3 md:px-5 focus:outline-none rounded text-sm md:text-base border border-blue-600`}
                />
              </Link>
            </div>
          )}
        </div>
        <div className='w-full flex flex-col md:flex-row justify-start md:justify-between mt-4 md:mt-8 text-sm'>
          <p className='flex gap-1 items-center px-3 py-1 text-slate-600 rounded-full'>
            <HiLocationMarker /> {info?.location ?? "No Location"}
          </p>
          <p className='flex gap-1 items-center px-3 py-1 text-slate-600 rounded-full'>
            <AiOutlineMail /> {info?.email ?? "No Email"}
          </p>
          <p className='flex gap-1 items-center px-3 py-1 text-slate-600 rounded-full'>
            <FiPhoneCall /> {info?.contact ?? "No Contact"}
          </p>
          <div className='flex flex-col items-center mt-10 md:mt-0'>
            <span className='text-xl'>{jobs?.length ?? 0}</span>
            <p className='text-blue-600'>Job Post</p>
          </div>
        </div>
      </div>
      <div className='w-full mt-20 flex flex-col gap-2'>
        <p>Jobs Posted</p>
        <div className='flex flex-wrap gap-3'>
          {Array.isArray(jobs) ? (
            
            jobs.map((job) => (
              <JobCard job={job} key={job._id} profileUrl={profileUrl} companies={info} isCompany={isCompany}  />
              
            ))
          ) : (
            <p>No jobs found</p>
          )}
        </div>
      </div>
      <CompanyForm open={openForm} setOpen={setOpenForm} />
    </div>
 );
};

export default CompanyProfile;
